import {
  WorkspaceSubscriptionProblem,
  WorkspaceSubscriptionProblemKey,
} from "lib/types/subscriptions/WorkspaceSubscriptionProblem";
import { SubscriptionBillingState } from "lib/types/subscriptions/SubscriptionBillingState";
import { WorkspaceSubscriptionStatus } from "lib/types/subscriptions/WorkspaceSubscriptionStatus";

export function getWorkspaceSubscriptionProblem(
  status: WorkspaceSubscriptionStatus,
): WorkspaceSubscriptionProblem | null {
  if (!status) return null;

  if (
    status.billingState === SubscriptionBillingState.None ||
    status.billingState === SubscriptionBillingState.Active
  )
    return null;
  if (
    status.billingState === SubscriptionBillingState.ActiveWithPastDuePayment
  ) {
    return {
      key: WorkspaceSubscriptionProblemKey.Overdue,
      bannerMessage: "Payment method",
      subscriptionStatusLabel: "Payment overdue",
      infoTitle: "Payment problem.",
      infoResolutionMessage:
        "Update your billing information to continue your subscription.",
      actionLabel: "Resolve",
    };
  }
  if (status.billingState === SubscriptionBillingState.Lapsed) {
    return {
      key: WorkspaceSubscriptionProblemKey.Lapsed,
      bannerMessage: "Payment method",
      subscriptionStatusLabel: "Subscription lapsed",
      infoTitle: "Subscription has lapsed.",
      infoResolutionMessage:
        "Reactivate your subscription to continue using your projects.",
      actionLabel: "Reactivate subscription",
    };
  }
  return null;
}
